import { jsx as _jsx } from "react/jsx-runtime";
export default (props) => {
    var _a;
    const src = props.variant === 'mark'
        ? '/assets/img/Wrench.png'
        : '/assets/img/SIMPLIFIX%20Logo%20HZ.png';
    return _jsx("img", { src: src, alt: (_a = props.alt) !== null && _a !== void 0 ? _a : 'Logo', className: props.className });
};
